import React from 'react';
import { Frame, useSageBreakpoint } from '@kajabi/sage-react';

import { useCheckout } from '../../context';
import { ExpressCheckout } from './ExpressCheckout';
import { Footer } from './Footer';
import { Header } from './Header';
import { InputFields } from './InputFields';
import { IntervalToggle } from './IntervalToggle';
import { SubmitButton } from './SubmitButton';
import { GoogleButton } from './GoogleButton';
import { TermsAndConditions } from './TermsAndConditions';

export const Form = () => {
  const { minified } = useCheckout();
  const breakpoints = useSageBreakpoint();
  const fullWidthValue = minified ? '560px' : '50%';

  return (
    <Frame
      align={Frame.ALIGNMENTS.TOP_CENTER}
      border={breakpoints.sm ? null : Frame.BORDERS.DEFAULT}
      borderRadius={Frame.BORDER_RADII.MD}
      gap={Frame.GAPS.MD}
      padding={Frame.PADDINGS[breakpoints.sm ? 'SM' : 'MD']}
      style={{ width: breakpoints.sm ? '100%' : fullWidthValue }}
      width={Frame.WIDTHS.HUG}
    >
      <Header />
      <IntervalToggle />
      <ExpressCheckout />
      <InputFields minified={minified} />
      <SubmitButton />
      <GoogleButton />
      <TermsAndConditions />
      <Footer />
    </Frame>
  );
};
